import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";

const MODELS = {
  openai: ["gpt-5.4", "gpt-5.4-mini", "gpt-5.2", "gpt-5", "gpt-4o"],
  anthropic: ["claude-sonnet-4-6", "claude-opus-4-8", "claude-haiku-4-5-20251001"],
  gemini: ["gemini-3-flash-preview", "gemini-3.1-pro-preview", "gemini-3.5-flash"],
};

export default function AdminAIProviders() {
  const [providers, setProviders] = useState([]);
  const load = () => api.get("/admin/ai-providers", adminApi()).then(({ data }) => setProviders(data));
  useEffect(() => { load(); }, []);

  const update = async (provider, changes) => {
    try {
      await api.patch(`/admin/ai-providers/${provider}`, changes, adminApi());
      toast.success("Güncellendi");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Hata (super admin gerekli)"); }
  };

  return (
    <div className="font-admin-body">
      <h1 className="font-admin-head text-3xl mb-2">AI Sağlayıcıları</h1>
      <p className="text-sm text-white/60 mb-6">
        Varsayılan olarak Emergent Universal Key kullanılır (tek anahtar, hepsi çalışır).
        Kendi API anahtarını girmek için "Kendi Anahtarımı Kullan"ı aç ve anahtarı yapıştır.
        <span className="text-[#F59E0B]"> Sadece Super Admin düzenleyebilir.</span>
      </p>

      <div className="space-y-4">
        {providers.map((p) => (
          <div key={p.provider} className="admin-card p-5" data-testid={`provider-${p.provider}`}>
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="font-admin-head text-xl capitalize">{p.provider}</div>
                <div className="text-xs text-white/50">
                  {p.use_own_key ? "Kendi anahtarın kullanılıyor" : "Emergent Universal Key kullanılıyor"}
                </div>
              </div>
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={!!p.is_enabled} onChange={(e) => update(p.provider, { is_enabled: e.target.checked })} className="accent-[#F59E0B]" data-testid={`enable-${p.provider}`} />
                Aktif
              </label>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={!!p.use_own_key} onChange={(e) => update(p.provider, { use_own_key: e.target.checked })} className="accent-[#F59E0B]" data-testid={`use-own-${p.provider}`} />
                Kendi Anahtarımı Kullan
              </label>
              <div>
                <label className="text-xs text-white/50">API Anahtarı</label>
                <input
                  type="password"
                  defaultValue=""
                  placeholder={p.own_api_key_masked || "sk-..."}
                  data-testid={`key-input-${p.provider}`}
                  onBlur={(e) => { if (e.target.value) update(p.provider, { own_api_key: e.target.value }); e.target.value = ""; }}
                  className="admin-input"
                />
              </div>
              <div>
                <label className="text-xs text-white/50">Varsayılan Model</label>
                <select value={p.default_model} onChange={(e) => update(p.provider, { default_model: e.target.value })} data-testid={`model-select-${p.provider}`} className="admin-input">
                  {(MODELS[p.provider] || []).map((m) => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
